var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16263 4.88951L9.7988 3.25334C10.5221 2.53002 11.5032 2.12366 12.5261 2.12366C13.549 2.12366 14.5301 2.53002 15.2534 3.25334C15.9767 3.97666 16.3831 4.9577 16.3831 5.98063C16.3831 7.00356 15.9767 7.9846 15.2534 8.70792L13.6172 10.3441M10.3445 13.6168L8.70789 15.2534C7.98456 15.9767 7.00353 16.3831 5.9806 16.3831C4.95766 16.3831 3.97663 15.9767 3.25331 15.2534C2.52998 14.5301 2.12363 13.5491 2.12363 12.5261C2.12363 11.5032 2.52998 10.5222 3.25331 9.79883L4.88988 8.16226",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07132 11.4351L11.435 7.0714",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.52e4431a15184b233aa1bfc4f76ca636.svg";
export { ForwardRef as ReactComponent };